// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3yIAp","bigColWidth":"Table_bigColWidth__y7G4s","biggerColWidth":"Table_biggerColWidth__34cfJ","row":"Table_row__3eGmY","col":"Table_col__2DMve"};